import axios from 'axios';
import AxiosMockAdapter from 'axios-mock-adapter';


const axiosInstance = axios.create();

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => Promise.reject((
//     error.response && error.response.data
//   ) || 'Something went wrong')
// );

export const mock = new AxiosMockAdapter(axiosInstance, { delayResponse: 0 });

mock
  // .onPost('/api/users/profile/new').reply(200, { data:{id:-1} })
  // .onPut('/api/users/profile/phone').reply(200, { verificationCodeId: 123 })
  .onAny()
  .passThrough()

mock.restore()

export default axiosInstance;
